import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, error) =>
        !('status' in error && [401, 403, 404].includes(Number(error.status))) && count < 1,
      refetchOnWindowFocus: false,
    },
  },
});
